import { Box, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CurrencySelect from '../../../../components/shared/CurrencySelect';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import { useTranslation } from 'react-i18next';
import useColor from '../../../../hooks/site/useColor';
import { API_USERS } from '../../../../api/users';
import { PieChart } from '@mui/x-charts';

export default function FinancePieChart({ userId, defaultCurrency }) {
  const { isBigDesktop } = useBootstrapSize();
  const { grey } = useColor();
  const { t } = useTranslation();
  const { success, error } = useColor();

  const [currencyInfo, setCurrencyInfo] = useState({});
  const [financeInfo, setFinanceInfo] = useState({});

  const isData = financeInfo.deposit || financeInfo.payout;

  const dataPieChat = isData
    ? [
        {
          id: 0,
          value: financeInfo.deposit,
          label: t('Deposits'),
          color: success.main
        },
        {
          id: 1,
          value: financeInfo.payout,
          label: t('Withdrawals'),
          color: error.main
        }
      ]
    : [
        {
          id: 0,
          value: 0,
          label: t('No data'),
          color: grey[300]
        }
      ];

  const currency = currencyInfo.currency;
  const currencyUserId = currencyInfo.userId;

  useEffect(() => {
    setCurrencyInfo({ currency: defaultCurrency, userId });
  }, [defaultCurrency, userId]);

  useEffect(() => {
    if (!userId) return;
    if (!currency) return;
    if (currencyUserId !== userId) return;

    API_USERS.info
      .finance({ userId, currency })
      .then((e) => {
        const data = e.data.data;
        setFinanceInfo(data);
      })
      .catch(console.error);
  }, [userId, currency, currencyUserId]);

  return (
    <Stack direction={'column'} gap={1}>
      <CurrencySelect
        value={currency}
        setValue={(val) => setCurrencyInfo((prev) => ({ ...prev, currency: val }))}
        hideLabel
      />
      <Box>
        <PieChart
          series={[{ data: dataPieChat }]}
          height={isData ? (isBigDesktop ? 130 : 100) : 40}
        />
      </Box>
    </Stack>
  );
}
